import styles from './Faqs.module.scss'
import classNames from 'classnames'

import { PortableText } from '@portabletext/react'

export default function Faqs({ faqs }) {
  return (
    <section className={styles.faqs}>
      {faqs.map(({ question, answer }, i) => (
        <FaqItem
          key={`faq_${i}`}
          question={question}
          answer={<PortableText value={answer} />}
        />
      ))}
    </section>
  )
}

function FaqItem({ question, answer }) {
  return (
    <div className={styles.faq}>
      <h2 className={classNames('h4', styles.question)}>{question}</h2>
      <div className={styles.answer}>{answer}</div>
    </div>
  )
}
